<template>
  <div >
    <ais-search-box
      placeholder="Search IMPA Code or description"
      :show-loading-indicator="true"
      class="w-full"
      @focus="searching"
    />
  </div>
</template>

<script>
export default {
  methods: {
      searching: function (event) {
          this.$router.push({ name: 'browse'})
      }
  }
}
</script>

<style>
  .ais-SearchBox-form {
    @apply relative items-center;
  }
  .ais-SearchBox-form input {
    @apply bg-gray-200 text-gray-900 w-full shadow-md border border-transparent rounded-lg py-2 pr-4 pl-8 block appearance-none;
  }
  .ais-SearchBox-submit {
    @apply pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center
  }
  .ais-SearchBox-loadingIndicator {
    @apply pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center
  }
  input[type="search"]::-webkit-search-cancel-button {
    display: none;
  }
  .ais-SearchBox-reset {
    @apply absolute inset-y-0 right-0 pr-3 flex items-center
  }
  .ais-SearchBox-submitIcon {
    width:15px;
    height:15px;
  }
  [hidden="hidden"] { 
    display: none;
  }
</style>